import React, { Component } from 'react';
import { connect } from 'react-redux';
import './VerifyEmail.css';
import memberActions from '../../actions/member';



class VerifyEmail extends Component {
  componentWillMount() {
    const { location, dispatch, router } = this.props;
    if (location.query.confirm) {
      localStorage.setItem('token', location.query.confirm)
      dispatch(memberActions.confirmEmail(location.query.confirm, router));
    } else {
      router.push('/');
    }
  }

  render() {
    return (
      <div className="saga-wrap">
        <div className="saga">
          <div className="forgot__form">
            <h1 className="forgot__title">Email Confirmation</h1>
            <div className="clear"></div>
          </div>
          <div className="clear"></div>
        </div>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    member: state.member
  })
)(VerifyEmail);



/** WEBPACK FOOTER **
 ** ./src/containers/VerifyEmail/index.js
 **/